import styled from "styled-components";

export const RootContainer = styled.div`
  padding: 0 16px;
`;

export const Title = styled.div`
  padding-top: 24px;
  padding-bottom: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
`;

export const Item = styled.div`
  padding: 14px 0px;
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  justify-content: center;
  align-items: center;

  border: 2px solid
    ${(props) => (props.status === "active" ? "#73217D" : "transparent")};
  border-radius: 10px;
  background-color: #fff;
  filter: drop-shadow(0px 3px 6px #00000029);

  @media screen and (max-width: 325px) {
    grid-gap: 6px;
    padding: 6px 0px;
  }
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: ${(props) => (props.status === "active" ? "#73217D" : "#000")};
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 100%;
  max-width: 50px;
  aspect-ratio: 1;
  object-fit: contain;

  @media screen and (max-width: 325px) {
    max-width: 40px;
  }
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
`;
